import { Controller } from "@hotwired/stimulus"

// The "Propose a booking" panel in a live conversation. It's
// data-turbo-permanent, so the chat refreshing itself (Inquiries::Broadcast)
// never closes it mid-way through; which also means nothing resets it after
// sending, so this closes and clears it once a request has gone.
export default class extends Controller {
  sent(event) {
    if (!event.detail.success) return

    this.element.querySelector("form")?.reset()
    this.element.open = false
  }
}
